import {twMerge} from '../../../common/twMerge';
import {SeparatorType} from '../../atoms/Separator/SeparatorType.enum';
import {BadgesWithSpace} from '../../molecules/BadgesWithSpace/BadgesWithSpace';
import {LabelBadge} from '../../molecules/LabelBadge/LabelBadge';
import {LabelBadge16Type} from '../../molecules/LabelBadge/LabelBadge16Type.enum';
import {LabelBadgeSizeType} from '../../molecules/LabelBadge/LabelBadgeSizeType.enum';
import {TextsWithSeparator} from '../../molecules/TextsWithSeparator/TextsWithSeparator';
import {MetadataProps} from './MetadataProps.interface';

export function Metadata({
  badgeList,
  badgeClassName,
  ageGradeBadge,
  texts,
  separatorType = SeparatorType.Line,
  subtitleStyle,
  subtitleClassName,
  separatorStyle,
  separatorClassName,
  useStaticDot,
  className,
  discountRateText,
  ...props
}: MetadataProps) {
  return (
    <div className={twMerge('flex items-center', className)} {...props}>
      {/* 할인율 뱃지 */}
      {discountRateText && (
        <LabelBadge
          sizeType={LabelBadgeSizeType.Size16}
          type={LabelBadge16Type.red}
          label={discountRateText}
          className="mr-4px px-4pxr"
        />
      )}
      {/* BM 뱃지 */}
      <BadgesWithSpace className={badgeClassName} badgeList={badgeList} />
      {/* 연령 뱃지 */}
      {ageGradeBadge && (
        <BadgesWithSpace
          className={twMerge(badgeClassName, 'px-5pxr')}
          badgeList={[ageGradeBadge]}
        />
      )}
      <TextsWithSeparator
        texts={texts}
        separatorType={separatorType}
        useStaticDot={useStaticDot}
        separatorClassName={twMerge(
          separatorType === SeparatorType.Line
            ? 'mx-4pxr h-8pxr bg-theme-transparent-20'
            : undefined,
          separatorClassName
        )}
        separatorStyle={separatorStyle}
        className={twMerge(
          'text-theme-solid-60',
          separatorType === SeparatorType.Line
            ? 'font-small2'
            : 'font-x-small1',
          subtitleClassName
        )}
        style={subtitleStyle}
      />
    </div>
  );
}
